export const INITIAL_DATA: { [key: string]: string } = {
  id: "",
  name: "",
  entityName: "",
};


